import { GET_VENDOR_LOGIN_REQUEST, GET_VENDOR_LOGIN_SUCCESS } from "./type";

export const getVendorLoginRequest = (cred) => {
    return {
        type: GET_VENDOR_LOGIN_REQUEST,
        payload: cred,
    };
};

export const getVendorLoginSuccess = (cred) => {
    return {
        type: GET_VENDOR_LOGIN_SUCCESS,
        payload: cred,
    };
};
